import type { App } from '../app';
import type { CallLog } from '../calllog/calllog';
import type { AppState, Store } from '../state/store';
import { renderCallBar } from './call-bar';
import { renderCallLog } from './calllog-view';
import { h } from './dom';

const REG_TEXT: Record<AppState['registration'], string> = {
  unregistered: 'Nicht angemeldet',
  registering: 'Verbinde …',
  registered: 'Bereit',
  failed: 'Anmeldung fehlgeschlagen',
};

export function renderPhoneView(root: HTMLElement, app: App, store: Store, callLog: CallLog): void {
  root.replaceChildren();
  const statusDot = h('span', { class: 'dot' });
  const statusText = h('span', {});
  const statusDetail = h('span', { class: 'muted small' });
  const message = h('p', { role: 'status', class: 'message' });
  const logout = h('button', { type: 'button', class: 'link' }, 'Abmelden');
  logout.addEventListener('click', () => app.logout());

  const number = h('input', { name: 'number', inputmode: 'tel', autocomplete: 'off', placeholder: 'Nummer oder Durchwahl' });
  const dialError = h('p', { role: 'alert', class: 'alert' });
  const dialForm = h('form', { class: 'card dial' }, number, h('button', { type: 'submit', class: 'primary call' }, 'Anrufen'), dialError);
  dialForm.addEventListener('submit', (e) => {
    e.preventDefault();
    dialError.textContent = app.dial(number.value) ?? '';
    if (!dialError.textContent) number.value = '';
  });

  const callBar = h('div', {});
  const badge = h('span', { class: 'badge' });
  const logToggle = h('button', { type: 'button', class: 'tab', 'aria-expanded': 'false' }, 'Anrufliste ', badge);
  const logBox = h('div', { hidden: '' });
  logToggle.addEventListener('click', () => {
    const open = logBox.hidden;
    logBox.hidden = !open;
    logToggle.setAttribute('aria-expanded', String(open));
    if (open) app.viewCallLog();
  });

  root.append(
    h('header', { class: 'topbar' }, h('div', {}, statusDot, statusText, ' ', statusDetail), logout),
    message,
    callBar,
    dialForm,
    h('section', { class: 'card' }, logToggle, logBox),
  );
  renderCallBar(callBar, app, store);
  renderCallLog(logBox, app, store, callLog);

  const update = (s: AppState) => {
    statusDot.className = `dot ${s.registration === 'registered' && s.transport === 'connected' ? 'ok' : 'warn'}`;
    statusText.textContent = `${REG_TEXT[s.registration]} – Durchwahl ${s.session.durchwahl ?? ''}`;
    statusDetail.textContent = s.session.sipExtension ? `(SIP ${s.session.sipExtension})` : '';
    message.textContent = s.message ?? '';
    badge.textContent = s.missedCount > 0 ? String(s.missedCount) : '';
    dialForm.hidden = s.call !== null;
  };
  store.subscribe(update);
  update(store.getState());
}
